var map = {
	"./global/ca-ES.json": 898,
	"./global/cs-CZ.json": 899,
	"./global/de-DE.json": 900,
	"./global/en-US.json": 901,
	"./global/es-ES.json": 902,
	"./global/fr-FR.json": 903,
	"./global/it-IT.json": 904,
	"./global/ja-JP.json": 905,
	"./global/nl-NL.json": 906,
	"./global/pl-PL.json": 907,
	"./global/pt-PT.json": 908,
	"./global/ro-RO.json": 909,
	"./global/tr-TR.json": 910,
	"./global/zh-CN.json": 911,
	"./regional/de-CH.json": 912,
	"./regional/en-AU.json": 913,
	"./regional/en-CA.json": 914,
	"./regional/en-IN.json": 915,
	"./regional/en-JP.json": 916,
	"./regional/en-UK.json": 917,
	"./regional/en-USA.json": 918,
	"./regional/es-AR.json": 919,
	"./regional/es-CO.json": 920,
	"./regional/es-EC.json": 921,
	"./regional/es-LT.json": 922,
	"./regional/es-MX.json": 923,
	"./regional/es-US.json": 924,
	"./regional/es-UY.json": 925,
	"./regional/fr-BE.json": 926,
	"./regional/fr-CA.json": 927,
	"./regional/fr-CH.json": 928,
	"./regional/fr-LU.json": 929,
	"./regional/it-CH.json": 930,
	"./regional/nl-BE.json": 931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;